import fitnessTraining1 from "../assets/home4.png";
import fitnessTraining2 from "../assets/home3.png";
import fitnessTraining3 from "../assets/home2.png";

// Home Swiper Images
import homeSwiperImh1 from "../assets/s1.jpg";
import homeSwiperImh2 from "../assets/s2.jpg";

// Trainers Data Images
import trainer2 from "../assets/trainers2.png";

// The Story Behind Our Gym imege
import story from "../assets/about5.png";

// allOurTrainersData Images
import ourTrainer1 from "../assets/home2.png";
import ourTrainer2 from "../assets/contact2.png";
import ourTrainer3 from "../assets/home4.png";
import ourTrainer4 from "../assets/cardio.png";
import ourTrainers1 from "../assets/trainers2.png";

import blogArticle1 from "../assets/blog2.png";
import blogArticle2 from "../assets/blog3.png";
import blogArticle3 from "../assets/blog4.png";
import blogArticle4 from "../assets/blog5.png";
import blogArticle5 from "../assets/blog6.png";
import blogArticle6 from "../assets/blog7.png";

// Small Images
import thumbnail1 from "../assets/blog8.png";
import thumbnail2 from "../assets/blog9.png";
import thumbnail3 from "../assets/blog10.png";
import thumbnail4 from "../assets/blog11.png";
import thumbnail5 from "../assets/blog12.png";
import thumbnail6 from "../assets/blog13.png";

export const headerLinksData = [
  {
    id: 1,
    title: "Home",
    to: "/",
  },
  {
    id: 2,
    title: "About",
    to: "/about",
  },
  {
    id: 3,
    title: "Classes",
    to: "/classes",
  },
  /* {
    id: 4,
    title: "Blog",
    to: "/blog",
  }, */
  {
    id: 4,
    title: "Contact",
    to: "/contact",
  },
];

export const trainersData = [
  {
    id: 1,
    name: "Mangesh Ghanekar",
    title: [
      "Weight Loss & Fat Management",
      " Strength & Muscle Building",
      "Functional & Injury-Specific Training",
      "Sports & Performance Training",
      "Nutrition & Lifestyle Coaching",
    ],
    image: trainer2,
    to: "https://www.linkedin.com/in/mangesh-ghanekar-553a94189/",
  },
];

export const ourPlansData = [
  {
    id: 1,
    title: "Basic",
    offer: "12000 / month",
    description: "30% Off for Beginners",
    icon: "fa-solid fa-heart",
    points: [
      "15 minutes of warm-up exercises",
      "20 minutes of strength training",
      "Access to 2 group classes per week",
      "Basic nutrition guidance",
    ],
  },
  {
    id: 2,
    title: "Standard",
    offer: "15000 / month",
    description: "Most popular",
    icon: "fa-solid fa-star",
    points: [
      "30 minutes of cardio",
      "30 minutes of strength training",
      "Access to 5 group classes per week",
      "Personalized nutrition plan",
    ],
  },
  {
    id: 3,
    title: "Premium",
    offer: "20000 / month",
    description: "10% Off",
    icon: "fa-solid fa-gem",
    points: [
      "45 minutes of cardio",
      "45 minutes of strength & functional training",
      "Unlimited access to all classes",
      "One-on-one coaching and advanced nutrition plan",
    ],
  },
  {
    id: 4,
    title: "Basic",
    offer: "1000 / Day",
    icon: "fa-solid fa-heart",
    points: [
      "15 minutes of warm-up exercises",
      "20 minutes of strength training",
      "Access to 2 group classes per week",
      "Basic nutrition guidance",
    ],
  },
  {
    id: 5,
    title: "Standard",
    offer: "1200 / Day",
    description: "Most popular",
    icon: "fa-solid fa-star",
    points: [
      "30 minutes of cardio",
      "30 minutes of strength training",
      "Access to 5 group classes per week",
      "Personalized nutrition plan",
    ],
  },
  {
    id: 6,
    title: "Premium",
    offer: "1500 / Day",
    description: "10 % Off",
    icon: "fa-solid fa-gem",
    points: [
      "45 minutes of cardio",
      "45 minutes of strength & functional training",
      "Unlimited access to all classes",
      "One-on-one coaching and advanced nutrition plan",
    ],
  },
];


export const articlesNewsData = [
  {
    id: 1,
    about: "Fitness",
    title: "5 Morning Exercises to Boost Your Energy",
    description: "Start your day with these simple exercises that increase metabolism, improve mood, and strengthen your muscles.",
  },
  {
    id: 2,
    about: "Health",
    title: "Understanding the Importance of Mental Health",
    description: "Learn how mindfulness, meditation, and proper rest can significantly improve your overall health and well-being.",
  },
  {
    id: 3,
    about: "Nutrition",
    title: "Top 10 Superfoods You Should Include in Your Diet",
    description: "Explore nutrient-rich foods that help boost immunity, improve digestion, and support long-term health.",
  },
  {
    id: 4,
    about: "Workout Tips",
    title: "How to Correctly Perform a Squat",
    description: "Master the perfect squat to avoid injury and maximize muscle engagement with these simple steps.",
  },
  {
    id: 5,
    about: "Lifestyle",
    title: "5 Daily Habits for a Healthier Life",
    description: "Incorporate these small habits into your daily routine to increase productivity and maintain wellness.",
  },
];


export const gymStoryData = [
  {
    id: 1,
    welcome: "👋 Welcome to M G Fitness",
  },  
];

export const valuesBoxes = [
  {
    id: 1,
    icon: "fa-regular fa-newspaper",
    title: "Certified trainer",
  },
  {
    id: 2,
    icon: "fa-solid fa-apple-whole",
    title: "Nutrition & diet",
  },

  {
    id: 3,
    icon: "fa-solid fa-person",
    title: "Years of experience",
  },
];

export const valuesNumbers = [
  {
    id: 1,
    number: "14+",
    description: "Year of Experience",
  },

  {
    id: 2,
    number: "100+",
    description: "Happy Clients",
  },

  {
    id: 3,
    number: "5k",
    description: "Instagram followers",
  },
];

export const allOurTrainersData = [
  {
    id: 1,
    title: "Muscle Building",
    image: ourTrainer1,
    to: "/",
  },

  {
    id: 2,
    title: "CrossFit",
    image: ourTrainer2,
    to: "/",
  },


  {
    id: 4,
    title: "Weight Loss",
    image: ourTrainer3,
    to: "/",
  },

  {
    id: 3,
    title: "Cardio",
    image: ourTrainer4,
    to: "/",
  },

];

export const ourTrainers = [
  {
    id: 1,
    image: ourTrainers1,
    name: "Mangesh Ghanekar",
  },
];

export const blogArticlesNewsData = [
  {
    id: 1,
    title: "The 10 best exercises to do in your park",
    name: "Jacob Cornish",
    image: blogArticle1,
    thumbnail: thumbnail1,
  },
  {
    id: 2,
    title: "How to Choose The Right Equipment For You",
    name: "Benjamin Gray",
    image: blogArticle2,
    thumbnail: thumbnail2,
  },
  {
    id: 3,
    title: "How to Maximum Time Spent at the Gym",
    name: "David Ferguson",
    image: blogArticle3,
    thumbnail: thumbnail3,
  },

  {
    id: 4,
    title: "Simple Condition for all Around Fitness.",
    name: "William Wilkins",
    image: blogArticle4,
    thumbnail: thumbnail4,
  },

  {
    id: 5,
    title: "How to Modify any Program to Improve Your Weakness",
    name: "Benjamin Gray",
    image: blogArticle5,
    thumbnail: thumbnail5,
  },

  {
    id: 6,
    title: `The Beginner’s Guide to Weight Lifting`,
    name: "Bernadette",
    image: blogArticle6,
    thumbnail: thumbnail6,
  },
];

export const contactInfoData = [
  {
    id: 1,
    title: "Phone",
    icon: "fa-solid fa-phone",
    cta: "+919763440018",
  },
  {
    id: 2,
    title: "Email",
    icon: "fa-solid fa-envelope",
    cta: "mgfitnesscoach67@gmail.com",
  },

  {
    id: 3,
    title: "Location",
    icon: "fa-solid fa-location-dot",
    cta: "Pune",
  },
];
